export default __webpack_public_path__ + "static/media/Group 434.cfb2af34.png";